import { FC, ReactNode } from 'react';

import { useBreakpoints } from '@mopla/utils';

import { Responsive } from '../../molecules/Responsive/Responsive';

import { FooterStyled, FooterWrapper } from './styled';

export interface IResponsive2ButtonsFooterProps {
	cancelBtn: ReactNode;
	submitBtn: ReactNode;
}

export const Responsive2ButtonsFooter: FC<IResponsive2ButtonsFooterProps> = ({
	cancelBtn,
	submitBtn,
}) => {
	const { isMobile } = useBreakpoints();

	return (
		<FooterWrapper>
			<Responsive mobile>{cancelBtn}</Responsive>
			<FooterStyled background={isMobile ? 'primary.main' : undefined}>
				<Responsive aboveMobile>{cancelBtn}</Responsive>
				{submitBtn}
			</FooterStyled>
		</FooterWrapper>
	);
};
